module.exports = __webpack_public_path__ + "static/media/footer-bg.f3e0cf55.png";